import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { logout, getMyData } from '../store/auth/actions'
import { getParamsFromQueryString, redirectToApp } from './url'

const mapStateToProps = (state) => ({
  isLogged: state.auth.isLogged,
  isFetching: state.auth.isFetching,
  user: state.auth.user,
  urlRedirect: state.app.urlRedirect
})

const mapDispatchToPros = dispatch =>
  bindActionCreators(
    {
      logout,
      getMyData
    },
    dispatch
  )

/**
 * It receives a component and returns the component that read the user token in the url
 * This HOC only must be used in private routes
 * @param {React.Component} ChildComponent
 * @returns React.Component
 */
const withUrlParams = (ChildComponent) => connect(mapStateToProps, mapDispatchToPros)(
  class WithUrlParamsHOC extends Component {
    static propTypes = {
      user: PropTypes.object.isRequired,
      isLogged: PropTypes.bool.isRequired,
      isFetching: PropTypes.bool.isRequired,
      getMyData: PropTypes.func.isRequired,
      urlRedirect: PropTypes.string
    }

    static defaultProps = {
      urlRedirect: undefined
    }

    state = { urlRedirect: null }

    componentDidMount () {
      const { user, isLogged } = this.props

      const urlRedirect = (
        getParamsFromQueryString().url_redirect ||
        this.props.urlRedirect
      )

      if (urlRedirect) {
        this.setState({ urlRedirect })
      }

      if (isLogged) this.props.getMyData(user.token)
    }

    componentDidUpdate (prevProps) {
      const { urlRedirect } = this.state
      const { isFetching, user } = this.props
      const { isFetching: prevIsFetching } = prevProps

      const hasUpdateUserData = prevIsFetching && !isFetching

      // Só volta pra app com token válido: sem token (getMyData falhou),
      // deixa as rotas renderizarem a tela de login normalmente
      if (urlRedirect && hasUpdateUserData && user && user.token) {
        redirectToApp(urlRedirect, user.token)
      }
    }

    render () {
      const { isFetching } = this.props
      const { urlRedirect: hasUrlRedirect } = this.state

      return !isFetching && !hasUrlRedirect && (
        <ChildComponent />
      )
    }
  }
)

export default withUrlParams
